import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import {  toast } from 'react-toastify';
import '../../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Config from "../../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { TextField } from '@mui/material';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import Backdrop from '@mui/material/Backdrop';

import FormHelperText from '@mui/material/FormHelperText';
function ApprovePopup(props) {
  const { refundID, pageContent, setPageContent, approvePopupOpen, setApprovePopupOpen } =  props;  
  const navigate    = useNavigate();
  const { t }       = useTranslation();
  const BASE        = Config.BASE;
  const TOKEN       = window.localStorage.getItem('token');
  const [refundApproveIsLoading, setRefundApproveIsLoading] = useState(false);

  const [transactionNo, setTransactionNo] = useState("");
  const [transactionNoError, setTransactionNoError] = useState(false);
  const [transactionNoHelperText, setTransactionNoHelperText] = useState('');

  const [transactionRemarks, setTransactionRemarks] = useState("");
           
  const handleApproveModelClose = () => { setApprovePopupOpen(false); };

  const handleChangeTransactionNo = (event) => {
    setTransactionNo(event.target.value);
    setTransactionNoError(false);
    setTransactionNoHelperText('');
  };

  const handleChangeTransactionRemarks = (event) => {
    setTransactionRemarks(event.target.value);
  };
  
  const handleRefundApproveSubmit = () => {
    
    if(transactionNo.trim() === "")
    {
        setTransactionNoError(true);
        setTransactionNoHelperText(t("Please enter the transaction reference no"));
        return;
    }

    let requestPayLoad = { 
                            id: refundID, 
                            adminRemarks: transactionRemarks,
                            transactionReferenceNumber: transactionNo
                         };

    setRefundApproveIsLoading(true);
    axios({      
          url     : BASE+"api/refund/approve",
          data    : requestPayLoad,
          method  : "POST",
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            setRefundApproveIsLoading(false);       

            const responseData           = response.data;
            const responseDataStatusCode = responseData.status ? responseData.status : 0;
            const responseMessage        = responseData.message ? responseData.message : '';
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {                
                (responseDataStatusCode === 1) ? toast.success(t(responseMessage)) : toast.error(t(responseMessage));
                    
                if(responseDataStatusCode === 1 && responseData)
                {
                  setApprovePopupOpen(false);

                  setPageContent({ ...pageContent, 
                                   refundedStatus: "approved", 
                                   adminRemarks: transactionRemarks,  
                                   transactionReferenceNumber: transactionNo,
                                   updatedAt: new Date()
                                 });
                }
            }        
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }   
        }).catch(function (error) {
          setRefundApproveIsLoading(false);  
          handleErrors(error, t, navigate);
        });
  }
  
  const approveModelLoad = () => {
    return (
        <Dialog open={approvePopupOpen} onClose={handleApproveModelClose}
          sx={{
            '& .MuiDialog-paper': {
              maxWidth: '500px', 
            },
          }}
        >
          <DialogTitle id="refund-approve-dialog" onClose={handleApproveModelClose}>
            {t("Refund Approve")}  
          </DialogTitle>         
          <DialogContent dividers>           

            <Grid container spacing={2} my={1}>
                <Grid item xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "text"
                        label = {t('Transaction Reference No')}
                        variant = "outlined" 
                        value = {transactionNo}                       
                        onChange={handleChangeTransactionNo}
                        error={transactionNoError}
                        required
                      />
                      <FormHelperText sx={{ position: 'absolute', bottom: -20, right: 0, color: 'red' }}>
                        {transactionNoHelperText}
                      </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl sx={{ margin: '10px 0px', width: '100%' }}>
                      <TextField 
                        type = "text"
                        multiline = {true}
                        label={t('Remarks')}
                        variant = "outlined" 
                        value = {transactionRemarks}                        
                        onChange={handleChangeTransactionRemarks}   
                      />                     
                    </FormControl>
                </Grid>               
              </Grid>  
              
          <Container className="buttonContainer">
            <Box>
              <Button key={"button-1"}                    
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleRefundApproveSubmit}>
                {t("Submit")}                    
              </Button>
              <Button key={"button-2"}                     
                variant="contained" 
                sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                onClick={handleApproveModelClose}>
                {t("close")}                    
              </Button>

              {refundApproveIsLoading ?      
              <Backdrop sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={refundApproveIsLoading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            : <></>}
            </Box>
        </Container>
      </DialogContent>
    </Dialog>  
    );
  }

  return (
          <>
          {approveModelLoad()}
          </>
         );
}
export default ApprovePopup;